import microuniversoApi from "app/api/microuniversoApi";
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { IOrcamento } from "app/types/IOrcamento";
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'


import globalMU from "globalMU";

declare var window:any

export type DefinirPedidoDeCompraItemInput = {
    identificadorItem: number,
    pedidoDeCompra: string
    atualizarEstadoLegadoImediatamente?: boolean
    itemLegado?:any
}

export async function definirPedidoDeCompraItem(input: DefinirPedidoDeCompraItemInput)  {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirPedidoCompraItem(
            store.getState().orcamento.IdentificadorOrcamento,
            input.identificadorItem,
            input.pedidoDeCompra
        )

        const obterItemOrcamentoLegado = () => input?.itemLegado ?? window.orcamentoController.model.get("ItensOrcamento").find(i => i.get("Identificador") == input.identificadorItem) 

        const atualizarOrcamentoLegado = () => {
            const orcamentoLegado = window.orcamentoController.model
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem)

            if (!input.atualizarEstadoLegadoImediatamente) {
                store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                    identificador: itemAtualizado.Identificador,
                    dadosItem: itemAtualizado
                }))
            } else {
                obterItemOrcamentoLegado()?.atualizar?.(itemAtualizado, true, true, true)
            }

            orcamentoLegado.atualizar(
                orcamentoAtualizado, 
                input.atualizarEstadoLegadoImediatamente == true, 
                true)

            if (!input.atualizarEstadoLegadoImediatamente) {
                store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
            }

            store.dispatch(atualizarItemAction({
                identificador: input.identificadorItem,
                dados: {UltimaInformacaoAtualizada: "PEDIDO_COMPRA"}
            }))
        }

        atualizarOrcamentoLegado()
        
    } finally {
        globalMU.unblockUI()
    }
}